import React from "react";

const FaceBookSVG = () => {
  return (
    <svg
      width="13"
      height="21"
      viewBox="0 0 13 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6443 12.2168L12.2666 8.59727H8.37582V6.24844C8.37582 5.2582 8.91932 4.29297 10.6619 4.29297H12.4307V1.21133C12.4307 1.21133 10.8255 0.966797 9.29085 0.966797C6.08671 0.966797 3.99233 2.70039 3.99233 5.83867V8.59727H0.430664V12.2168H3.99233V20.9668H8.37582V12.2168H11.6443Z"
        fill="white"
      />
    </svg>
  );
};

export default FaceBookSVG;
